import { render, staticRenderFns } from "./AddIntegrationBulkTef.vue?vue&type=template&id=231598a2"
import script from "./AddIntegrationBulkTef.vue?vue&type=script&lang=js"
export * from "./AddIntegrationBulkTef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports